const jQ = jQuery.noConflict();

class minimizeHeaderOnScroll{

	constructor(){
		this.headerMain = ".header-main";
		this.body = "body";
	}
	minTheHeaderOnScroll(){

		if(jQ(window).scrollTop() > 100){
			jQ(this.headerMain).addClass("header-minimized");
			jQ(this.body).addClass("header-minimized");
		}
		else{
			if(jQ(this.headerMain).hasClass("header-minimized")){
				jQ(this.headerMain).removeClass("header-minimized");
				jQ(this.body).removeClass("header-minimized");
			}
		}
	}

	init(){
		this.minTheHeaderOnScroll();
	}

}

const minHeaderOnScroll = new minimizeHeaderOnScroll();

export default minHeaderOnScroll;



// WEBPACK FOOTER //
// ./app/themes/nordic-concert-halls/js/utils/minimizeheaderonscroll.js